import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import * as serviceWorker from './serviceWorker';
import * as Msal from 'msal';

import AuthContext from './services/auth';
import { getEnvDetail } from './utils/env';

const envDetail = getEnvDetail();

// Add here the scopes that you would like the user to consent during sign-in
const loginRequest = {
  scopes: ['openid', 'profile', 'offline_access'],
};

// Add here the scopes to request when obtaining an access token for MS Graph API
const tokenRequest = {
  scopes: [envDetail.endpointApi],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
};
// if the user is already logged in you can acquire a token

if (AuthContext && AuthContext.getAccount()) {
  AuthContext.acquireTokenSilent(tokenRequest)
    .then(token => {
      if (token) {
        const isOneApp = JSON.parse(localStorage.getItem('isOneApp')) ?? false;
        if (!isOneApp) {
          window.FreshworksWidget('identify', 'ticketForm', {
            name: token.account.name,
            email: token.account.userName,
          });
        }
        ReactDOM.render(<App />, document.getElementById('root'));
      }
    })
    .catch(error => {
      // console.warn('silent token acquisition fails. acquiring token using popup');
      AuthContext.acquireTokenRedirect(tokenRequest);
      // .then(tokenResponse => {
      //   if (tokenResponse) {
      //     ReactDOM.render(<App />, document.getElementById('root'));
      //   }
      // })
      // .catch(error => {
      //   // console.error(error);
      // });
      // if (error instanceof Msal.InteractionRequiredAuthError) {
      //   // fallback to interaction when silent call fails

      // } else {
      //   // console.warn(error);
      // }
    });
} else {
  // user is not logged in, you will need to log them in to acquire a token
  AuthContext.loginRedirect(loginRequest);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
